export default "__VITE_ASSET__DYHcL29X__"